import { Flex, ModalCloseButton, useBreakpointValue } from "@chakra-ui/react";
import config from "config/config";
import { useEffect } from "react";
import { appendExternalScript } from "utils/appendExternalScript/appendExternalScript";

const { affilid, scriptUrl } = config.kiwiWidget;

export const KiwiWidget = () => {
  useEffect(() => {
    let script: HTMLScriptElement;
    const appendWidgetScript = async () => {
      script = await appendExternalScript(scriptUrl, { "data-affilid": affilid });
    };
    appendWidgetScript();

    return () => {
      if (script) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <ModalCloseButton
        position="absolute"
        top={2}
        right={2}
        color="primary.900"
        _hover={{ color: "primary.500", bg: "white" }}
        _active={{ color: "primary.700", bg: "white" }}
        size={useBreakpointValue({ base: "lg", lg: "md" })}
        aria-label="Close language switcher"
      />
      <Flex pt={14} minH="100vh" id="widget-holder" />
    </>
  );
};
